import styled from '@mui/system/styled';

export const DashboardsTemplatesHeaderCnt = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 30px',
  '& button .requestReportIcon': {
    fontSize: '20px',
    color: '#fff',
  },
});

export const HeaderHeading = styled('div')({
  fontSize: '20px',
  fontWeight: 700,
  lineHeight: '32px',
});
export const SubHeading = styled('div')({
  color: '#424242',
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 'normal',
});
